export default __webpack_public_path__ + "static/media/guia-azure.fbb7d885.pdf";